export function formatDate(dateString, options) {
  let defaultOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
  if (options)
    defaultOptions = options

  return new Date(dateString).toLocaleDateString(undefined, defaultOptions);
};

export function formatTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}


const catalanWeekdays = [
  'diumenge', 'dilluns', 'dimarts', 'dimecres', 'dijous', 'divendres', 'dissabte'
];
const occitanWeekdays = [
  'dimenge', 'diluns', 'dimars', 'dimècres', 'dijòus', 'divendres', 'dissabte'
];

export function getDayName(date, lang) {
  const weekdays = lang === 'oc' ? occitanWeekdays : catalanWeekdays;
  const day = weekdays[date.getDay()];
  return day
}


const catalanMonths = [
  'gener', 'febrer', 'març', 'abril', 'maig', 'juny',
  'juliol', 'agost', 'setembre', 'octubre', 'novembre', 'desembre'
];
const catalanPrepositionMonths = [
  'de gener', 'de febrer', 'de març', "d'abril", 'de maig', 'de juny',
  'de juliol', "d'agost", 'de setembre', "d'octubre", 'de novembre', 'de desembre'
];
const occitanMonths = [
  'genièr', 'febrièr', 'març', 'abril', 'mai', 'junh',
  'julhet', 'agost', 'setembre', 'octòbre', 'novembre', 'decembre'
];
const occitanPrepositionMonths = [
  'de genièr', 'de febrièr', 'de març', "d'abril", 'de mai', 'de junh',
  'de julhet', "d'agost", 'de setembre', "d'octòbre", 'de novembre', 'de decembre'
];

export function getMonthName(date, lang, preposition) {
  const caMonths = preposition ? catalanPrepositionMonths : catalanMonths
  const ocMonths = preposition ? occitanPrepositionMonths : occitanMonths

  const months = lang === 'oc' ? ocMonths : caMonths;
  const day = date.getDate();
  const month = months[date.getMonth()];
  return month
}